export default "__VITE_ASSET__pJY937pS__"